"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _scss = require("@scss");

var _Link = _interopRequireDefault(require("Link"));

var _stylesModule = _interopRequireDefault(require("./../styles.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Dropdown = /*#__PURE__*/(0, _react.memo)(function Dropdown(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      classes = _ref.classes,
      menuOnClick = _ref.menuOnClick;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _scss.cls)(_stylesModule["default"]['dropdown'])
  }, items.map(function (item, m) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: m
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], _extends({}, item, !!menuOnClick && {
      onClick: function onClick(e) {
        return menuOnClick(e, item === null || item === void 0 ? void 0 : item.href);
      }
    }, {
      classes: {
        root: (0, _scss.cls)(classes === null || classes === void 0 ? void 0 : classes.submenuItem, item.className),
        active: (0, _scss.cls)(item.active && _stylesModule["default"]['active'])
      }
    }), item.title));
  }));
});
var _default = Dropdown;
exports["default"] = _default;